<template>
    <v-layout column justify-center align-center>
        <!-- 로그인 -->
        <v-sheet v-if="hasNoUser" width="400">
            <v-card-title> 로그인이 필요한 페이지입니다 </v-card-title>
            <v-card-text> <login-card /> </v-card-text>
        </v-sheet>

        <!-- 권한없음 -->
        <v-sheet v-else-if="isNotPerson || isNotApplicant">
            <v-card-title>권한이 없습니다.</v-card-title>
            <v-card-text> 사용하실 수 없는 페이지입니다. </v-card-text>
            <v-card-actions> <v-btn @click="$router.go(-1)">이전으로</v-btn> <v-btn @click="logout"> 로그아웃 </v-btn> </v-card-actions>
        </v-sheet>

        <!-- 양식 -->
        <v-sheet v-else width="1080" max-width="95%" class="fill-height">
            <meeting-view-tabs v-bind="{ meeting }">
                <template #tab-complete-actions>
                    <v-btn href="/dashboard/schedules" color="primary">대시보드 가기</v-btn>
                </template>
            </meeting-view-tabs>
        </v-sheet>

        <!-- 로더 -->
        <v-fade-transition>
            <v-overlay v-show="loading" color="transparent">
                <v-progress-circular size="100" width="5" color="primary" indeterminate />
            </v-overlay>
        </v-fade-transition>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initMeeting, USER_TYPES } from "@/assets/variables";

import LoginCard from "@/components/client/login/login-card.vue";
import MeetingViewTabs from "@/components/dashboard/person/meeting/view/meeting-view-tabs.vue";
import { mapMutations } from "vuex";

export default {
    components: {
        LoginCard,
        MeetingViewTabs,
    },
    props: {
        _meeting: { type: String },
    },
    data: () => ({
        meeting: initMeeting(),

        loading: false,
    }),
    computed: {
        payload() {
            return this.$store.state.payload;
        },
        hasNoUser() {
            return !this.payload?._user;
        },
        isNotPerson() {
            return this.payload?.userType != USER_TYPES.PERSON.value;
        },
        isNotApplicant() {
            return !this.meeting;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        payload() {
            this.init();
        },
    },
    methods: {
        ...mapMutations(["logout"]),
        async init() {
            if (this.hasNoUser) return;
            if (this.isNotPerson) return;
            if (this.loading) return;
            this.loading = true;

            try {
                const { meeting } = await api.v1.person.meetings.get({ _id: this._meeting });
                this.meeting = meeting;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>